export const segmentationDefinition = [
	{
		title: 'Repeat Customers',
		content:
			'Clients who have completed two or more cases with the firm, regardless of the outcome (won or lost).',
	},
	{
		title: 'One-Time Customers',
		content:
			'Clients who have completed one case with the firm, regardless of the outcome (won or lost).',
	},
	{
		title: 'In-Progress Customers',
		content:
			'Clients who have an active case but have not yet completed any cases.',
	},
	{
		title: 'Recently Registered Customers',
		content:
			'Clients who have just signed up and do not have any ongoing cases.',
	},
	{
		title: 'Disengaged Customer',
		content:
			'Clients whose cases are on hold or canceled. Clients who registered but didn’t apply for any cases within their first six months. Clients who reactivated their account after previously deleting it.',
	},

	{
		title: 'Flagged Customers',
		content:
			'Clients flagged during a review or cleanup process by the client wizard.',
	},
];
